'use strict';

require('./KayleeService');
require('./RoomService');
var screenfull = require('screenfull');
var Log = require('../../log/Log');
var log = Log.channel('SystemInfoController');
var defaults = require ('../../defaults/Defaults');

angular.module('inara').controller('SystemInfoController', SystemInfoController);

SystemInfoController.$inject = ['$scope', '$state', '$timeout', 
                                '$ionicPopup', 'ionicMaterialInk', 
                                'KayleeService', 'RoomService', 'DeviceService',
                                '$window', 'gettextCatalog'];

function SystemInfoController($scope, $state, $timeout, 
                              $ionicPopup, ionicMaterialInk, 
                              KayleeService, RoomService, DeviceService,
                              $window, gettextCatalog) {
    log.info('initializing');

    var vm = this;
    var versionHeldTimeout = null;
    var devPasswordPrompt = null;
    var controller = null;
    vm.company = null;
    vm.enterSetup = function() { RoomService.enterSetup(); };
    vm.getConnectedLabel = function() {
        /// Mira Portal connected status
        return gettextCatalog.getString('Connected');
    };
    vm.getInaraVersionLabel = function() {
        /// Label for Mira Connect version in Mira Connect system information
        return gettextCatalog.getString('{{inaraName}} Version',
            { inaraName: defaults.inara.name });
    };
    vm.getUsername = getUsername;
    vm.getViewTitle = function() {
        /// Title bar on system information screen
        return gettextCatalog.getString('System Information');
    };
    vm.getNotConnectedLabel = function() {
        /// Mira Portal connected status
        return gettextCatalog.getString('Not connected');
    };
    vm.isBrowser = function() { return !angular.isDefined($window.cordova); };
    vm.isFullScreenSupported = function() { return vm.isBrowser() && screenfull.enabled; };
    vm.isMalConnected = function() { return KayleeService.isConnected(); };
    vm.logout = function() { KayleeService.signOut(); };
    vm.onVersionHeld = onVersionHeld;
    vm.onVersionReleased = onVersionReleased;
    vm.portalName = defaults.mal.name;
    vm.room = null;
    vm.showLogoutButton = function() {
        return !KayleeService.isAuthenticatedAsAnonymousRemoteControl() &&
            KayleeService.isAuthenticatedAsUser();
    };
    vm.site = null;
    vm.toggleFullScreen = function() { screenfull.toggle(); };

    if (angular.isDefined($window.cordova)) {
        $window.cordova.getAppVersion.getVersionNumber().then(function(data) {
            vm.appVersion = data;
        });        
    }

    $scope.$on('$stateChangeSuccess', onStateChange);

    ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });

    RoomService.onStateChanged(onRoomServiceStateChanged);    

    $scope.$on('$destroy', function() {
        RoomService.offStateChanged(onRoomServiceStateChanged);
        if (controller !== null) {
            controller.$offChange(onControllerChanged);
            controller = null;
        }
    });

    function getUsername() {
        if (KayleeService.isAuthenticatedAsAnonymousRemoteControl()) {
            /// Value for remote control user on system information page
            return gettextCatalog.getString('Remote Control');
        } else if (KayleeService.isAuthenticatedAsUser()) {
            return KayleeService.getUser().email;
        } else if (KayleeService.isAuthenticatedAsController()) {
            return defaults.inara.name;
        }
        /// Value for unknown username on system information page
        return gettextCatalog.getString('Unknown');
    }

    function onControllerChanged(ctrl) {
        if (angular.isDefined(ctrl.roomId)) {
            vm.room = KayleeService.getRoom(ctrl.roomId);
            vm.room.$loaded().then(function() {
                vm.site = KayleeService.getSite(vm.room.siteId);
                vm.company = KayleeService.getCompany(vm.room.companyId);
            });
        } else {
            vm.room = null;
            vm.site = null;
            vm.company = null;
        }
    }

    function onRoomServiceStateChanged(state) {
        if (RoomService.isControllerLoaded()) {
            if (controller === null) {
                controller = RoomService.getController();
                if (controller !== null) {
                    // controller is paired, watch it for changes
                    controller.$onChange(onControllerChanged);                    
                } else {
                    // no controller paired, this could be UI preview mode,
                    // so get the room passed into RoomService
                    vm.room = RoomService.getRoom();
                    if (vm.room !== null) {
                        vm.site = KayleeService.getSite(vm.room.siteId);
                        vm.company = KayleeService.getCompany(vm.room.companyId);
                    } else {
                        vm.site = null;
                        vm.company = null;
                    }
                }
            }
            if (!angular.isDefined($window.cordova)) {
                // For remote control, get version number from room controller
                vm.room.$getControllers().$loaded().then(function(controllers) {
                    if (controllers.length === 0) {
                        /// Value for unknown application version on system information page
                        vm.appVersion = gettextCatalog.getString('Unknown');
                        return;
                    }
                    for (var i = 0; i < controllers.length; i++) {
                        if (controllers[i].hasOwnProperty('appVersion')) {
                            vm.appVersion = controllers[i].appVersion;
                            break;
                        }
                    }
                });
            }
        } else if (controller !== null) {
            controller.$offChange(onControllerChanged);
            controller = null;
        }
    }

    function onStateChange(event, toState, toParams, fromState, fromParams) {
        if (fromState.name === 'info.system') {
            if (devPasswordPrompt !== null) {
                devPasswordPrompt.close();
            }
        }
    }

    function onVersionHeld() {
        if (!vm.isBrowser()) versionHeldTimeout = $timeout(onVersionHeldTimeout, 4500);
    }

    function onVersionHeldTimeout() {
        // Hack: use a hidden submit to support the Enter softkey so we don't
        // have to create a whole custom popup form.
        devPasswordPrompt = $ionicPopup.prompt({
            template:
                '<form>' + 
                    '<input ng-model="data.response" type="text" ' +
                        'placeholder="Enter Developer Password" autofocus></input>' +
                    '<input type="submit" ng-click="$buttonTapped(buttons[1], $event)" ' +
                        'style="position: absolute; left: -9999px; width: 1px; height: 1px;"/>' +
                '</form>',
            cssClass: 'dev-password',
            okType: 'button-theme'
        });

        devPasswordPrompt.then(function(res) {
            devPasswordPrompt = null;
            if (res === '28362774') {
                log.debug('password correct');
                $state.go('info.developer');
            } else {
                log.debug('password incorrect');
            }
        });
    }

    function onVersionReleased() {
        if (versionHeldTimeout !== null) {
            $timeout.cancel(versionHeldTimeout);
            versionHeldTimeout = null;
        }
    }
}

module.exports = SystemInfoController;
